import { UserProfile } from '../models/User.model';
import { useUserStore } from '../stores/User.store';

export const useUserDetails = (): UserProfile => {
  const userProfile = useUserStore((state) => state.userProfile);
  return userProfile;
};

export default useUserDetails;
